import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { ProductsSection } from '../sections/products-section'

const Outer = styled.div``

type ProductListPageProps = {

}
export const ProductListPage: FunctionComponent<ProductListPageProps> = () => {
  return <Outer>
    <ProductsSection />
  </Outer>
}